import { create } from 'zustand'

export const useNotifStore = create((set) => ({
    notifs: [],
    removeNotif: (notif) => set((state) => ({ notifs : state.notifs.filter((t) => t.text !== notif) })),
    addNotif: (newNotif) => set((state) =>({ notifs: [...state.notifs, newNotif] })),
    updateNotifs: (newNotifs) => set(() => ({ notifs: newNotifs })),
    clearNotifs: () => set({ notifs: [] }),
}))
